import {Dimensions} from 'react-native';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import {css} from 'styled-components';

import Feather from 'react-native-vector-icons/Feather';
import styled from 'styled-components/native';

const {height, width} = Dimensions.get('window');

export const LottieContainer = styled.View`
  width: 100%;
  height: ${RFPercentage(25)}px;
  padding: 0 24px;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.View`
  padding: 0 24px;
  flex: 1;
`;

export const Title = styled.Text`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.black};
  font-family: ${({theme}) => theme.fonts.semibold};
  text-align: center;
  margin-bottom: ${RFValue(12)}px;
`;

export const ModalContent = styled.View`
  width: ${width - 20}px;
  flex: 1;
  max-height: ${height * 0.80}px;
  background-color: ${({theme}) => theme.colors.shape};
  border-radius: ${RFValue(16)}px;
  overflow: hidden;
`;

export const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${RFValue(12)}px ${RFValue(12)}px;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border_light};
`;

export const HeaderTitle = styled.Text`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.black};
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const CloseButton = styled.TouchableOpacity`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  justify-content: center;
  align-items: center;
`;

export const CloseButtonText = styled.Text`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.black};
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const Container = styled.ScrollView.attrs({
  showsVerticalScrollIndicator: true,
  bounces: false,
  contentContainerStyle: {
    paddingBottom: 20,
  },
})`
  padding: ${RFValue(0)}px;
  background: ${({theme}) => theme.colors.shape};
`;

export const Description = styled.Text`
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text_fixed};
  margin-bottom: ${RFValue(20)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  text-align: center;
`;

export const List = styled.View`
  margin-bottom: ${RFValue(16)}px;
`;

export const HowItWorksTitle = styled.Text`
  color: ${({theme}) => theme.colors.black};
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-bottom: ${RFValue(12)}px;
`;

export const TableContainer = styled.View`
  border-radius: ${RFValue(8)}px;
  overflow: hidden;
  border: 1px solid ${({theme}) => theme.colors.border};
`;

export const TableHeader = styled.View`
  background-color: ${({theme}) => theme.colors.primary};

  flex-direction: row;
`;

export const TableHeaderText = styled.Text`
  font-size: ${RFValue(14)}px;
  color: white;
    padding: ${RFValue(8)}px;
  flex: 1;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const TableRow = styled.View`
  flex-direction: row;

  background-color: ${({theme}) => theme.colors.background};
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
`;

export const TableRowText = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text};
  flex: 1;
    padding: ${RFValue(8)}px;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const ModalFooter = styled.View`
  padding: ${RFValue(20)}px 24px;
`;

export const ButtonContainer = styled.View`
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;
export const ButtonBack = styled.TouchableOpacity`
  height: ${RFValue(45)}px;
  width: 35%;
  justify-content: center;
  align-items: center;
  margin-right: ${RFValue(12)}px;
  padding-left: 4px;
  border-radius: ${RFValue(12)}px;
`;
export const ButtonBackText = styled.Text`
  color: ${({theme}) => theme.colors.black};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ButtonConfirm = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.primary};
  height: ${RFValue(35)}px;
  flex: 1;
  justify-content: center;
  align-items: center;
  border-radius: ${RFValue(26)}px;
`;
export const ButtonConfirmText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

interface ICellProps {
  isFocused?: boolean;
}

export const CellContainer = styled.View<ICellProps>`
  width: ${RFValue(38)}px;
  height: ${RFValue(38)}px;
  shadow-color: #000;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.1;
  shadow-radius: 4px;
  elevation: 5;

  background-color: ${({theme}) => theme.colors.shape};
  border-radius: ${RFValue(10)}px;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.regular};
  margin: ${RFValue(4)}px;
  justify-content: center;
  align-items: center;

  ${({isFocused}) =>
    isFocused &&
    css`
      border: 2px solid ${({theme}) => theme.colors.primary};
    `}
`;

export const CellText = styled.Text`
  font-size: ${RFValue(20)}px;
`;

export const CodeContainer = styled.View`
  margin-top: ${RFValue(12)}px;
  flex-direction: row;
  justify-content: center;
`;

export const ErrorText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.attention};
  font-family: ${({theme}) => theme.fonts.regular};
  text-align: center;
  margin-top: ${RFValue(12)}px;
`;

export const CloseButtonIcon = styled(Feather)`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.black};
`;

export const Divider = styled.View`
  height: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
  border-top-width: 1px;
  border-top-style: solid;
  margin: ${RFValue(12)}px 0;
  background-color: ${({theme}) => theme.colors.border};
width: 100%;
`;

export const LinkButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;  
  justify-content: center;
`;
